import { AttributeEnums } from "../../shared/utilities/enums/attributeEnums";
import { StringEnums } from "../../shared/utilities/enums/stringEnums";
import { HelperUtils } from "../../shared/utilities/helperUtils";
import { IReviewWidgetOptionBase, ReviewWidgetOptionBase } from "./reviewWidgetOptionBase";

export interface IReviewWidgetSummaryComponentOption extends IReviewWidgetOptionBase {
    totalReviews: number;
    ratingCount: number;
    update: (isDisabled: boolean, isSelected: boolean, totalReviews: number, ratingCount: number) => void;
}

export class ReviewWidgetSummaryComponentOption extends ReviewWidgetOptionBase implements IReviewWidgetSummaryComponentOption {
    constructor(public htmlElement: HTMLElement, isDisabled: boolean, isSelected: boolean, public totalReviews: number, public ratingCount: number ) {
        super(htmlElement, isDisabled, isSelected);
    }
        
    setOptionMeter(): void {
        let summaryOptionMeter: HTMLMeterElement = this.htmlElement.querySelector(HelperUtils.addDataAttributeTags(AttributeEnums.ReviewWidgetRatingsOption.ratingsOptionMeter))
        summaryOptionMeter.value = this.ratingCount;
        summaryOptionMeter.max = this.totalReviews;
    }

    setOptionReviewTotal(): void {
        let summaryOptionReviewTotal: HTMLElement = this.htmlElement.querySelector(HelperUtils.addDataAttributeTags(AttributeEnums.ReviewWidgetRatingsOption.ratingsOptionTotal))
        summaryOptionReviewTotal.innerHTML = `${this.ratingCount}`;
    }

    setIsSelectedCssClass():void{
        console.log(`ReviewWidgetSummaryComponentOption: setActiveCssClass - ${this.isSelected}`);
        if(this.isSelected){
            this.htmlElement.classList.add(StringEnums.CssClass.LbActive);
        }else{
            this.htmlElement.classList.remove(StringEnums.CssClass.LbActive);
        }
    }

    updateIsSelected(isSelected: boolean):void{
        this.isSelected = isSelected;
        this.setIsSelectedCssClass();
    }

    updateOptionMeter(totalReviews: number, ratingCount: number):void{
        this.totalReviews = totalReviews;
        this.ratingCount = ratingCount;
        this.setOptionMeter();
    }

    updateOptionReviewTotal(totalReviews: number):void{
        this.totalReviews = totalReviews;
        this.setOptionReviewTotal();
    }

    update(isSelected: boolean, isDisabled: boolean, totalReviews: number, ratingCount: number):void{
        this.updateIsSelected(isSelected);
        this.updateIsDisabled(isDisabled);
        this.updateOptionMeter(totalReviews, ratingCount);
        this.updateOptionReviewTotal(totalReviews);
    }

    dispose(): void {
      
    }
}